import React from "react";
import "@/App.css";
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
    Navigate,
} from "react-router-dom";
import { Toaster } from "sonner";

import Home from "@/pages/Home";
import Divisions from "@/pages/Divisions";
import Bim from "@/pages/Bim";
import BimInquiry from "@/pages/BimInquiry";
import BuildingMaterials from "@/pages/BuildingMaterials";
import RealEstate from "@/pages/RealEstate";
import Consulting from "@/pages/Consulting";
import Contact from "@/pages/Contact";
import AdminLogin from "@/admin/AdminLogin";
import AdminDashboard from "@/admin/AdminDashboard";
import { useAttribution } from "@/hooks/useAttribution";

function ScrollToTop() {
    const { pathname } = useLocation();
    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    }, [pathname]);
    return null;
}

function App() {
    // useAttribution is retained as a first-touch UTM capture hook for future
    // paid campaigns. It's a no-op unless a form reads getAttribution().
    useAttribution();
    return (
        <div className="App">
            <BrowserRouter>
                <ScrollToTop />
                <Toaster
                    theme="dark"
                    position="top-right"
                    richColors
                    closeButton
                    toastOptions={{
                        style: {
                            background: "var(--bg-elevated)",
                            border: "1px solid var(--border-default)",
                            color: "var(--text-primary)",
                        },
                    }}
                />
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/divisions" element={<Divisions />} />
                    <Route path="/bim" element={<Bim />} />
                    <Route path="/bim/inquiry" element={<BimInquiry />} />
                    <Route
                        path="/building-materials"
                        element={<BuildingMaterials />}
                    />
                    <Route path="/real-estate" element={<RealEstate />} />
                    <Route path="/consulting" element={<Consulting />} />
                    <Route path="/contact" element={<Contact />} />

                    {/* Phase 6 — silent redirects for legacy routes */}
                    <Route
                        path="/business-funding"
                        element={<Navigate to="/" replace />}
                    />
                    <Route
                        path="/business-funding/apply"
                        element={<Navigate to="/" replace />}
                    />
                    <Route
                        path="/zenme-online"
                        element={<Navigate to="/" replace />}
                    />

                    <Route path="/admin/login" element={<AdminLogin />} />
                    <Route path="/admin/leads" element={<AdminDashboard />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </BrowserRouter>
        </div>
    );
}

export default App;
